import styled from 'styled-components';
import { White2 } from '../styles/colours';

export const Content = styled.section`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: scroll;
  background: ${White2};
`;
